import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow, IconButton } from '@material-ui/core';
import { House } from '@material-ui/icons';
import ModalBarcode from '../../common/ModalBarcode';
import StatusKey from '../../common/StatusKey';
import { HouseKeyComments } from '../../HousekeyComments';
import { RolePermissions } from '../../../domain/constants/RolePremissions';
import { SystemActions } from '../../../domain/constants/SystemActions';
import { useSelector } from 'react-redux';
import { Housekey } from '../../../redux/housekeys/models/Housekey';
import { LoanP2PModal } from '../LoanP2PModal';
import { mediumDate, mediumTime } from '../../../helpers/datetime';
import { StatusP2POption } from '../../../domain/constants/StatusP2PTransfer';

const LoanP2Prow = ({ loans_p2p }: { loans_p2p: any }) => {
  const { auth } = useSelector((state: any) => state);
  const allowEdit = RolePermissions.allowed(
    Number(auth.type),
    SystemActions.edit_keys
  );
  const {
    id,
    origin_user_id,
    target_user_id,
    origin_name,
    target_name,
    p2p_transfer_status_id,
    created,
    finished,
  } = loans_p2p;
  const isExceededLoan = Number(loans_p2p.loans_p2p?.days_past_due) < 0;

  const navigate = useNavigate(); // habilitar navigate para redirección
  const [showBarcode, setShowBarcode] = useState(false);
  const [selectedTransferP2PKey, setSelectedTransferP2PKey] = useState<
    number | null
  >(null);

  // función que redirige de forma programada
  const redirectEdition = (id: number) => {
    navigate(`/housekeys/edit/${id}`, { replace: true });
  };
  const openCommentHandler = (id: any): void => {
    console.log('Open id', id);
    setSelectedTransferP2PKey(id);
  };
  const closeCommentHandler = (): void => {
    setSelectedTransferP2PKey(null);
  };
  const getStatusString = (id: number) => {
    let obj = StatusP2POption.find((item) => item.id === id);
    return obj?.name;
  };
  return (
    <TableRow key={`loans-p2p-row-${id}`}>
      <TableCell component='th' scope='row'>
        {id}
      </TableCell>
      <TableCell>
        {origin_name} ({origin_user_id}){' '}
      </TableCell>
      <TableCell>
        {target_name} ({target_user_id})
      </TableCell>
      <TableCell>{getStatusString(p2p_transfer_status_id)}</TableCell>
      <TableCell>
        {mediumDate(created, '--')}
        <br />
        {mediumTime(created, '')}
      </TableCell>
      <TableCell>
        {mediumDate(finished, '--')}
        <br />
        {mediumTime(finished, '')}
      </TableCell>
      <TableCell align='right'>
        <div>
          <IconButton
            aria-label='ver llaves'
            size='medium'
            onClick={() => openCommentHandler(id)}
          >
            <House color='primary' />
          </IconButton>
        </div>
      </TableCell>
      {selectedTransferP2PKey && (
        <LoanP2PModal
          p2p_transfer_id={selectedTransferP2PKey}
          target_user_id={target_user_id}
          p2p_transfer_status_id={p2p_transfer_status_id}
          open
          onClose={closeCommentHandler}
        />
      )}
    </TableRow>
  );
};

export default LoanP2Prow;
